/**
 * Scroll Reveal
 * Fades in .pattern-container elements when they enter the viewport.
 * Elements already in view on load appear instantly (no transition).
 * Off-screen elements animate in when ~40% from the bottom of the viewport.
 */
// if (!document.body.classList.contains('block-editor-page')) {
//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach((entry) => {
//       if (entry.isIntersecting) {
//         entry.target.classList.add('is-visible');
//         observer.unobserve(entry.target);
//       }
//     });
//   }, {
//     rootMargin: '0px 0px -40% 0px',
//     threshold: 0,
//   });

//   requestAnimationFrame(() => {
//     document.querySelectorAll('.pattern-container').forEach((el) => {
//       const rect = el.getBoundingClientRect();
//       const inView = rect.top < window.innerHeight && rect.bottom > 0;

//       if (inView) {
//         // Already visible on load — show instantly, no animation
//         el.classList.add('no-transition', 'is-visible');
//         requestAnimationFrame(() => el.classList.remove('no-transition'));
//       } else {
//         observer.observe(el);
//       }
//     });
//   });
// }


if (!document.body.classList.contains('block-editor-page')) {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                staggerItems(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, {
        rootMargin: '0px 0px -40% 0px',
        threshold: 0,
    });

    /**
     * Build the ordered list of stagger items for a .pattern-container.
     *
     * Pass-through wrappers are expanded so their children become the stagger items:
     *   .pattern-grid → .pattern-column → content elements (headings, body-copy, etc.)
     *   .list-items and .accordions-group are excluded here — they're handled separately
     *   in staggerItems() with their own sub-stagger sequence.
     *
     * Single stagger units (not expanded — animate as one block):
     *   .cards-grid, .locations-grid, .team-grid, standalone .button-group, etc.
     *   Individual cards inside these wrappers are never touched.
     */
    const getStaggerItems = (container) => {
        const items = [];
        Array.from(container.children).forEach((child) => {
            if (child.matches('.pattern-grid')) {
                Array.from(child.children).forEach((col) => {
                    if (col.matches('.pattern-column')) {
                        Array.from(col.children).forEach((colChild) => {
                            // Skip list/accordion wrappers — their children are sub-staggered separately
                            if (!colChild.matches('.list-items, .accordions-group')) {
                                items.push(colChild);
                            }
                        });
                    } else {
                        items.push(col);
                    }
                });
            } else {
                items.push(child);
            }
        });
        return items;
    };

    const staggerItems = (container, isInstant = false) => {
        const items = getStaggerItems(container);

        // Find all list and accordion wrappers anywhere inside this container
        // and build a flat list of their children for sub-staggering
        const subWrappers = container.querySelectorAll('.list-items, .accordions-group');

        if (isInstant) {
            items.forEach((item) => {
                item.style.transition = 'none';
                item.style.opacity = '1';
                item.style.transform = 'translateY(0)';
            });
            subWrappers.forEach((wrapper) => {
                Array.from(wrapper.children).forEach((child) => {
                    child.style.transition = 'none';
                    child.style.opacity = '1';
                    child.style.transform = 'translateY(0)';
                });
            });
            container.classList.add('is-visible');
        } else {
            items.forEach((item, index) => {
                item.style.transitionDelay = `${index * 0.1}s`;
            });
            // Each list/accordion wrapper staggers its own children independently
            subWrappers.forEach((wrapper) => {
                Array.from(wrapper.children).forEach((child, index) => {
                    child.style.transitionDelay = `${index * 0.08}s`;
                });
            });
            requestAnimationFrame(() => {
                container.classList.add('is-visible');
            });
        }
    };

    // Run on load
    document.querySelectorAll('.pattern-container').forEach((el) => {
        const rect = el.getBoundingClientRect();
        const inView = rect.top < window.innerHeight && rect.bottom > 0;

        if (inView) {
            staggerItems(el, true);
        } else {
            observer.observe(el);
        }
    });
}